import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { afterItems, beforeItems } from "../data/landing";
export function BeforeAfter() {
  return <section className="bg-cream px-5 py-16 text-navy-900 sm:py-20" data-id="element-39" data-mp="3ogavnrgxf35u">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="3oi40r2bw5fbq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-41" data-mp="3sgl8no34ytu7">
          <p className="text-sm font-bold text-gold-600" data-id="element-42" data-mp="3sj7jbwlbppgn">A more structured approach to complete denture assessment</p>
          <h2 className="mt-3 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-43" data-mp="3jgerns88bbqa">
            From Searching Through Scattered Notes to Having a Clear Reference System at Your Fingertips
          </h2>
          <div className="mt-5 space-y-3 text-base leading-relaxed text-navy-700" data-id="element-44" data-mp="39qbvxk9q3jo9">
            <p data-id="element-45" data-mp="2vrcasmlf5mwu">As dentists, we accumulate knowledge from textbooks, lectures, continuing education, and clinical experience.</p>
            <p data-id="element-46" data-mp="30p5e97vc82tf">But when a complete denture case becomes challenging, finding the right information at the right moment can be frustrating.</p>
            <p data-id="element-47" data-mp="x6n165fgwtlk">I created Denture Blueprint™ to help you bring that information together in one organized, practical reference system.</p>
          </div>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-48" data-mp="171f13fwivsji">
          <div className="rounded-3xl border-2 border-red-200 bg-white p-6" data-id="element-49" data-mp="123wpfhr4ez7t">
            <div className="flex items-center gap-3" data-id="element-50" data-mp="121u0l11pfc4o">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-51" data-mp="ef4044507pm6"><XIcon className="h-6 w-6" aria-hidden="true" data-id="element-52" data-mp="9g0vulwulnf9" /></span>
              <h3 className="text-xl font-extrabold text-red-700" data-id="element-53" data-mp="o3lxschzlgll">Before Denture Blueprint™</h3>
            </div>
            <ul className="mt-5 space-y-3" data-id="element-54" data-mp="jcndz2xsi0dl">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-navy-700" data-id="element-55" data-mp="3rsp5t58li93q">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-56" data-mp="3mu5kn71tt1cf" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-gold-400 bg-navy-900 p-6 text-white shadow-xl" data-id="element-57" data-mp="1vpu9tspaus6s">
            <div className="flex items-center gap-3" data-id="element-58" data-mp="20gizr3lbzh3t">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-500 text-white" data-id="element-59" data-mp="20h2kes2d8jlj"><CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-60" data-mp="24hmfzr7ajf5k" /></span>
              <h3 className="text-xl font-extrabold text-gold-300" data-id="element-61" data-mp="17sn84damcfdw">With Denture Blueprint™</h3>
            </div>
            <ul className="mt-5 space-y-3" data-id="element-62" data-mp="1crzvr09bdqhj">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-navy-200" data-id="element-63" data-mp="1gsa6srbyr739">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-64" data-mp="1lrwmd7f9kzf8" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug" data-id="element-65" data-mp="2x5s2ojhwne81">
          My goal is simple: help you spend less time searching for information and more time using your professional knowledge effectively.
        </p>
        <div className="mt-8" data-id="element-66" data-mp="2xkxaltk8hwpj">
          <CTAButton label="Get Access to the Complete System" data-id="element-67" data-mp="2xk5f0iqmzyz9" />
        </div>
      </div>
    </section>;
}